<template>
  <div class="flex-grow-1">
    <header-bar />
    <purple-card v-if="systemData" :data="systemData" />
    <black-card v-if="systemData" :data="systemData" />
    <user-systems-card
      v-if="configurator.currentVenue"
      :data="configurator.currentVenue"
    />
    <!-- <venues-card :data="configurator" /> -->
    <bulk-content-card v-if="systemData" :content="systemData.bulkContent" />
    <purple-card2 v-if="systemData" :data="systemData" />
    <footer-bar />
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import headerBar from '@/components/shared/HeaderBar.vue';
  import footerBar from '@/components/shared/FooterBar.vue';
  import blackCard from '@/components/venueDetails/BlackCard.vue';
  import userSystemsCard from '@/components/venueDetails/UserSystemsCard.vue';
  import purpleCard from '@/components/venueDetails/PurpleCard.vue';
  import purpleCard2 from '@/components/venueDetails/PurpleCard2.vue';
  // import venuesCard from '@/components/venueDetails/RelatedVenuesCard.vue';
  import bulkContentCard from '@/components/shared/BulkContentCard.vue';

  export default {
    props: {
      data: {
        type: Object,
        default: null
      },
      venueName: String,
      systemName: String
    },
    metaInfo() {
      // Only try to access metaTitle/Description if systemData is available
      if (!this.systemData) {
        return {};
      }
      return {
        title: this.systemData.metaTitle,
        meta: [
          { name: 'title', content: this.systemData.metaTitle },
          { name: 'description', content: this.systemData.metaDescription }
        ]
      };
    },
    components: {
      headerBar,
      footerBar,
      blackCard,
      userSystemsCard,
      purpleCard,
      purpleCard2,
      bulkContentCard
    },
    data() {
      return {
        systemData: this.data
      };
    },
    /**
     * Lifecycle hook that is called when a component is created
     *
     * @param to
     * @param from
     * @param next
     */
    beforeRouteUpdate(to, from, next) {
      console.log('beforeRouteUpdate', to, from);
      next();
      this.refreshVenue();
    },
    methods: {
      refreshVenue() {
        this.$store
          .dispatch('configurator/getVenueDetails', this.venueName)
          .then((response) => {
            this.systemData = response;
          })
          .catch((error) => {
            console.error('Error fetching venue details', error);
            this.$router.push({ name: 'home' });
          });
      }
    },
    computed: {
      ...mapState(['configurator'])
    },

    mounted() {
      this.refreshVenue();
    }
  };
</script>

<style scoped></style>
